<template>
  <div>
    <div class="min-vh">
      <div class="d-flex justify-content-between p-3 p-sm-0">
        <b-row class="no-gutters w-100">
          <b-col cols="12" md="2" class="my-1">
            <h1 class="mb-0 header-main text-uppercase d-inline">USER LIST</h1>
          </b-col>
          <b-col cols="12" md="10" class="my-1">
            <div class="d-flex justify-content-end">
              <b-input-group class="mr-3">
                <b-form-input
                  v-model="filter.search"
                  placeholder="Search Name, Employee ID"
                  @keydown.enter="handleSearch"
                />
                <b-input-group-append>
                  <b-button @click="search" class="search-button">
                    <font-awesome-icon icon="search" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>

              <b-button class="btn-export" @click="$refs.modalExport.show()">
                <span>EXPORT CUSTOMER</span>
              </b-button>
              <b-dropdown
                id="dropdown-filter"
                variant="outline"
                right
                ref="dropdownfilter"
                class="filter-custom mr-2 ml-2"
              >
                <template v-slot:button-content>
                  <font-awesome-icon icon="filter" class="mr-2" />FILTER
                </template>
                <div>
                  <p class="mb-2 dropdown-date-custom-text">Role</p>
                  <hr class="mt-0 mb-1" />
                  <b-row>
                    <b-col cols="6">
                      <b-form-checkbox class="mt-1" v-model="roleId" value="3">
                        Super Admin
                      </b-form-checkbox>
                      <b-form-checkbox class="mt-1" v-model="roleId" value="4">
                        Team Admin
                      </b-form-checkbox>
                    </b-col>
                    <b-col cols="6">
                      <b-form-checkbox class="mt-1" v-model="roleId" value="2">
                        Agent
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <p class="my-2 dropdown-date-custom-text">Team</p>
                  <InputSelect
                    v-model="filter.teamRoleMappingId"
                    title=""
                    name="team"
                    :options="teamList"
                    @onDataChange="handleChangeType"
                    valueField="roleMappingId"
                    textField="name"
                  />
                  <b-button
                    class="btn submit-button btn-secondary w-100 mt-2"
                    @click="search()"
                  >
                    <span class="ml-2">Search</span>
                  </b-button>
                </div>
              </b-dropdown>
              <b-dropdown
                right
                variant="outline"
                class="filter-custom export mr-2"
                :disabled="!items.length"
              >
                <template v-slot:button-content> EXPORT </template>
                <b-dropdown-item @click="exportFile()"
                  >EXPORT FILE</b-dropdown-item
                >
                <b-dropdown-item @click="exportQrcode()"
                  >EXPORT QR CODE</b-dropdown-item
                >
              </b-dropdown>
              <router-link to="/user/details/0">
                <b-button class="btn-main">
                  <div>
                    <font-awesome-icon icon="user-plus" />
                    <span class="ml-2">CREATE USER</span>
                  </div>
                </b-button>
              </router-link>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="mt-3 bg-white-border p-3">
        <b-row class="no-gutters px-3 px-sm-0">
          <b-col>
            <b-table
              class="table-list"
              striped
              responsive
              hover
              :items="items"
              :fields="fields"
              :busy="isBusy"
              show-empty
              empty-text="ไม่พบข้อมูล"
            >
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(employeeId)="data">
                <span class="text-center" v-if="data.item.employeeId"
                  >{{ data.item.employeeId }}
                </span>
                <span v-else>-</span>
              </template>
              <template v-slot:cell(roleId)="data">
                <div class="d-flex justify-content-center">
                  <span class="text-center"
                    >{{ formatRole(data.item.roleId) }}
                  </span>
                </div>
              </template>
              <template v-slot:cell(team)="data">
                <div
                  class="d-flex justify-content-center"
                  v-if="data.item.team.length"
                >
                  <span
                    v-for="(name, index) in data.item.team"
                    v-bind:key="index"
                    class="text-nowrap"
                  >
                    {{ name
                    }}<span
                      class="mx-1"
                      v-if="index + 1 != data.item.team.length"
                      >,</span
                    >
                  </span>
                </div>
                <span v-else>-</span>
              </template>
              <template v-slot:cell(active)="data">
                <div class="d-flex justify-content-center">
                  <span v-if="data.item.active" class="text-success"
                    >Active
                  </span>
                  <span v-else class="text-danger">Inactive</span>
                </div>
              </template>
              <template v-slot:cell(createdTime)="data">
                <div class="d-flex justify-content-center">
                  {{ formatDate(data.item.createdTime) }}
                </div>
              </template>
              <template v-slot:cell(qrCode)="data">
                <div class="d-flex justify-content-center">
                  <b-button variant="view" @click="showQrCode(data.item)">
                    <font-awesome-icon icon="eye" title="View" />
                  </b-button>
                </div>
              </template>
              <template v-slot:cell(id)="data">
                <div class="d-flex justify-content-center">
                  <router-link :to="'/user/details/' + data.item.userGUID">
                    <b-button variant="link" class="text-link px-1 py-0">
                      <font-awesome-icon
                        icon="pencil-alt"
                        class="text-warning"
                        title="View"
                      />
                    </b-button>
                  </router-link>
                  <!-- <b-button
                    variant="link"
                    class="text-danger px-1 py-0"
                    :disabled="true"
                    @click="openModalDelete(data.item)"
                  >
                    <font-awesome-icon icon="trash-alt" title="Delete" />
                  </b-button> -->
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row class="no-gutters px-3 px-sm-0">
          <b-col
            class="form-inline justify-content-center justify-content-sm-between"
          >
            <div v-if="rows > 0" class="my-auto">
              Showing {{ startPage | numeral("0,0") }} to
              {{ endPage | numeral("0,0") }} of
              {{ rows | numeral("0,0") }} entires
            </div>
            <div v-else class="my-auto">{{ rows }} entire</div>
            <div class="d-sm-flex m-3">
              <b-pagination
                v-model="filter.pageNo"
                :total-rows="rows"
                :per-page="filter.perPage"
                class="m-md-0"
                @change="pagination"
                align="center"
              ></b-pagination>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMessage"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="ModalAlertConfirm"
      @confirm="btnDelete"
    />
    <ModalQrCode ref="modalQrCode" />
    <ModalLoading ref="modalLoading" :text="msgModal" :hasClose="false" />
    <ModalExport ref="modalExport" @confirmEmail="exportExcelToEmail" />
  </div>
</template>

<script>
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import InputSelect from "@/components/inputs/InputSelect";
import ModalQrCode from "./component/ModalQrCode.vue";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalExport from "@/components/modal/ModalExport";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "UserIndex",
  components: {
    ModalAlertConfirm,
    ModalLoading,
    InputSelect,
    ModalQrCode,
    ModalExport,
  },
  data() {
    return {
      selected: null,
      msgModal: null,
      teamList: [{ roleMappingId: null, name: "Select Team" }],
      modalMessage: "",
      startPage: 1,
      endPage: 10,
      activeItem: "",
      requestDeleteUser: {
        userId: null,
      },
      fields: [
        {
          key: "employeeId",
          label: "Employee ID",
          class: "w-100px",
        },
        {
          key: "username",
          label: "Username",
          class: "w-100px",
        },
        {
          key: "firstname",
          label: "First Name",
          class: "w-100px",
        },
        {
          key: "lastname",
          label: "Last Name",
          class: "w-100px",
        },
        {
          key: "roleId",
          label: "Role",
          class: "w-100px",
        },
        {
          key: "team",
          label: "Team",
          class: "w-100px",
        },
        {
          key: "createdTime",
          label: "Register Date/Time",
          class: "w-180px",
        },
        {
          key: "active",
          label: "Status",
          class: "w-100px",
        },
        {
          key: "qrCode",
          label: "QR Code",
          class: "w-90px",
        },
        {
          key: "id",
          label: "",
          class: "w-action",
        },
      ],
      items: [],
      listAll: [],
      isBusy: false,
      value: false,
      rows: 0,
      roleId: "",
      filter: {
        search: "",
        pageNo: 1,
        perPage: 10,
        teamRoleMappingId: null,
      },
      filterListAll: {
        search: "",
        pageNo: 1,
        perPage: 999,
      },
      filterTeam: {
        search: "",
        pageNo: 1,
        perPage: 999,
      },
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      totalRowMessage: "",
      isDisable: false,
      checkAll: false,
      selectAllCb: false,
    };
  },
  created: async function () {
    await this.pagination(1);
    await this.getListTeam();
    await this.getListAll();
  },
  computed: {
    ...mapGetters(["getBrandDetail"]),
  },
  methods: {
    async exportExcelToEmail(email) {
      await this.exportCustomer(email);
    },
    getList: async function () {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/user/List`, this.filter)
        .then((data) => {
          if (data.result == 1) {
            this.items = data.detail.userList;
            this.rows = data.detail.count;
            this.isBusy = false;
          }
        });
    },
    getListAll: async function () {
      await this.axios
        .post(`${this.$baseUrl}/user/List`, this.filterListAll)
        .then((data) => {
          if (data.result == 1) {
            this.listAll = data.detail.userList;
          }
        });
    },
    exportQrcode: async function () {
      const listUserExport = this.roleId
        ? this.listAll.filter((e) => e.roleId === +this.roleId)
        : this.listAll;

      const arr = listUserExport.map((e) => e.userGUID);

      this.msgModal = "In progress";
      this.$refs.modalLoading.show();
      await this.axios
        .post(
          `${this.$baseUrl}/user/List-export-qrcode`,
          { adminGuids: arr },
          {
            responseType: "blob",
          }
        )
        .then((data) => {
          this.$refs.modalLoading.hide();
          var dateExcel = moment().format("YYYYMMDD");
          this.handleDownloadFile(data, `qrcode-${dateExcel}`, "zip");
        });
    },
    exportFile: async function () {
      this.msgModal = "In progress";
      this.$refs.modalLoading.show();
      await this.axios
        .post(`${this.$baseUrl}/user/List-export`, this.filter, {
          responseType: "blob",
        })
        .then((data) => {
          this.$refs.modalLoading.hide();
          var dateExcel = moment().format("YYYYMMDD");
          this.handleDownloadFile(data, `user-${dateExcel}`);
        });
    },
    handleDownloadFile(file, fileName, type = "xlsx") {
      var fileURL = window.URL.createObjectURL(new Blob([file]));
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", `${fileName}.${type}`);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    async exportCustomer(email) {
      this.$refs.modalLoading.show();

      const bodyPayload = {
        brandId: this.getBrandDetail()?.id,
        ...email,
      };

      try {
        const response = await this.axios.post(
          `${this.$baseUrl}/MessageLog/Export/ExportUser/${
            this.getBrandDetail()?.id
          }`,

          bodyPayload
        );
        if (response.result === 1) {
          this.$store.commit("UPDATE_GLOBAL_ALERT", {
            isShow: true,
            msg: response.detail,
          });
          this.$refs.modalExport.hide();
        } else {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: "ทำการส่งไฟล์ไม่สำเร็จ",
          });
        }
      } catch (e) {
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: "ทำการส่งไฟล์ไม่สำเร็จ" + e.message,
        });
      } finally {
        this.$refs.modalLoading.hide();
      }
    },
    handleChangeType(value) {
      this.filter.teamRoleMappingId = value;
    },
    formatDate(value) {
      if (value) {
        let newDate = new Date(value);
        newDate.setHours(newDate.getHours());
        const date = `${moment(value).format("DD MMM YYYY")} (${moment(
          newDate
        ).format("HH:mm")})`;
        return date;
      }
    },
    formatRole(id) {
      switch (id) {
        case null:
          return "-";
        case 2:
          return "Agent";
        case 3:
          return "Super Admin";
        case 4:
          return "Team Admin";
      }
    },
    handleSearch(e) {
      if (e.keyCode === 13) {
        this.filter.pageNo = 1;
        this.getList();
        this.getShowingPage(1);
      }
    },
    search() {
      if (this.roleId) {
        this.filter.roleId = this.roleId;
      } else {
        delete this.filter.roleId;
      }
      this.filter.pageNo = 1;
      this.$refs.dropdownfilter.hide(false);
      this.getList();
      this.getShowingPage(1);
    },
    getListTeam: async function () {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/Team/list/name`, this.filterTeam)
        .then((data) => {
          if (data.result == 1) {
            this.teamList = this.teamList.concat(data.detail.data);
          }
        });
      this.isBusy = false;
    },
    async onDeleteData() {
      this.$refs.ModalAlertConfirm.hide();
      await this.axios
        .delete(`${this.$baseUrl}/apitrigger/${this.bodyDelete.id}`)
        .then(async (data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            await this.pagination(1);
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getList();
      this.getShowingPage(Page);
    },
    async getShowingPage(page) {
      let result = await this.$getShowingPage(page, this.filter);
      this.startPage = result.startPage;
      this.endPage = result.endPage;
    },
    hanndleChangePerpage(value) {
      this.filter.pageNo = 1;
      this.filter.perPage = value;
      this.getList();
    },
    openModalDelete(value) {
      this.requestDeleteUser.userId = value.userGUID;
      this.modalMessage = "คุณต้องการลบ " + value.username + " ใช่หรือไม่?";
      this.$refs.ModalAlertConfirm.show();
    },
    btnDelete: async function () {
      this.$refs.ModalAlertConfirm.hide();
      await this.axios
        .delete(`${this.$baseUrl}/user/${this.requestDeleteUser.userId}`)
        .then(async (data) => {
          if (data.result == 1) {
            this.filter.PageNo = 1;
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            await this.pagination(1);
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        });
    },
    showQrCode(item) {
      this.$refs.modalQrCode.show(item);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dropdown-menu-right {
  min-width: 400px;
}
::v-deep .input-group-append {
  height: 35px;
}

::v-deep .export .dropdown-menu-right {
  min-width: 200px !important;
  padding: 5px;
}

.submit-button,
.btn-custom {
  background-color: #5b57a5;
  color: white;
  border-radius: 4px;
}
.action-div {
  text-align: end;
}
.btn-view {
  text-decoration: underline;
  color: #7160c4;
}
.btn-export {
  background-color: #5b57a5;
  color: white;
  border-radius: 4px;
  width: 250px;
}

.btn-export span {
  white-space: nowrap;
}

@media (max-width: 767px) {
  .action-div {
    text-align: center;
  }
  .btn-export {
    width: 100%;
  }
}
@media (max-width: 1728px) {
  .btn-export {
    width: 350px;
  }
}
</style>
